import './SPAddUser.scss';
import { Box, Button, Divider, Typography } from '@mui/material';
import { doFormErrorMsgs } from '../../../pages/SellerProfile/APIs/Helpers';
//import { SpApiAddUser } from '../../../pages/SellerProfile/APIs/SellerProfileAPI';
import { useEffect } from 'react';
import editForm from '../Form/json/editUserProfileFormFields.json';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//import GetLabels from '../../../pages/SellerProfile/GetLabels';
import SPForm from '../Form/SPForm';
import SPFormButton from '../Form/SPFormButton';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAddUsers,
  resetSuccess,
  setIsAddingUser,
  setFormLoading,
  setShowSuccessPopUp,
  setErrorMsg,
  setOnboardCompletePopupDetails,
  setaddingUserError
} from '../../../redux/slices/sellerProfileSlice';

function AddEditUser() {
  const dispatch = useDispatch();
  //const [loading, setLoading] = useState(false);
  const {
    onboardingStatus,
    addSuccess,
    isAddingUser,
    user_approved,
    spPageText,
    formUpdates,
    addinguserError,
    isLoading
  } = useSelector((state: any) => state.sellerProfile);
  const { t } = useTranslation();
  const successMsgNotApproved = t('sellerProfile.dashboard.addUserSuccess');
  const successMsgApproved = t('sellerProfile.dashboard.addUserApproved');
  const dividerStyle = {
    background: '#EFEFEF',
    marginBlock: '12px',
    marginInline: { xs: '-16px', md: '0px' }
  };

  // const submitFormFields = async (formName) => {
  //   setLoading(true);
  //   await SpApiAddUser(context, dispatch)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         context.setIsAddingUser(false);
  //         context.setFormUpdates({ ...context.formUpdates, [formName]: {} });
  //         if (res.data.user_approved) {
  //           context.setShowSuccessPopUp(successMsgApproved);
  //         } else {
  //           context.setShowSuccessPopUp(successMsgNotApproved);
  //         }
  //         if (!onboardingStatus.user && onboardingStatus?.completed === 2) {
  //           context.setOnboardCompletePopupDetails({
  //             show: true,
  //             navigate: false,
  //             close: true
  //           });
  //         }
  //       } else {
  //         doFormErrorMsgs(res, context.setErrorMsg, context.spPageText);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((res) => {
  //       setLoading(false);
  //       const errMsg = res.response?.data?.err_code || 'errorGeneral';
  //       context.setErrorMsg(context.spPageText[`error${errMsg}`]);
  //       window.scrollTo({ top: 200, behavior: 'smooth' });
  //     });
  // };

  useEffect(() => {
    if (addSuccess) {
      dispatch(setIsAddingUser(false));
      if (user_approved.user_approved) {
        dispatch(setShowSuccessPopUp(successMsgApproved));
        dispatch(resetSuccess(false));
        //
      } else {
        dispatch(setShowSuccessPopUp(successMsgNotApproved));
      }
      if (!onboardingStatus.user && onboardingStatus?.completed === 2) {
        dispatch(
          setOnboardCompletePopupDetails({
            show: true,
            navigate: false,
            close: true
          })
        );
      }
      dispatch(resetSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addSuccess]);

  useEffect(() => {
    if (addinguserError) {
      doFormErrorMsgs(addinguserError, dispatch, spPageText);
      dispatch(
        setShowSuccessPopUp({
          message: t('sellerProfile.dashboard.errorGeneral'),
          successType: 'error'
        })
      );
      dispatch(setaddingUserError(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addinguserError]);

  const submitFormFields = async (formName) => {
    try {
      dispatch(
        setAddUsers({
          formUpdates: formUpdates
        })
      );
    } catch (error: any) {
      const errMsg = error.response?.data?.err_code || 'errorGeneral';
      console.log('error', errMsg);
      dispatch(setErrorMsg(spPageText[`error${errMsg}`]));
      window.scrollTo({ top: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    dispatch(setFormLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="addEditUserContainer">
      <Divider sx={dividerStyle} />
      <Button
        variant="text"
        onClick={() => {
          dispatch(setIsAddingUser(!isAddingUser));
        }}
        className="addNewUserBtn"
      >
        <Typography>{t('sellerProfile.dashboard.addNewUser')}</Typography>
        {isAddingUser ? <ExpandLessIcon /> : <ExpandMoreIcon />}{' '}
      </Button>

      {isAddingUser && (
        <Box className="addUserForm">
          <SPForm formFields={editForm} formName="addUser" key="addUserForm" />
          <div style={{display:"flex", flexDirection:"row-reverse"}}>
          <SPFormButton
            label={t('sellerProfile.dashboard.addUser')}
            formName="addUser"
            handleClick={() => submitFormFields('addUser')}
            showLoading={isLoading}
          />
          </div>
         
        </Box>
      )}
      <Divider sx={dividerStyle} />
    </Box>
  );
}

export default AddEditUser;
